/**
 * HomeScrollIndicator
 * -------------------
 * Minimal "SCROLL ↓" hint anchored to the bottom of the Home split
 * hero. Bounces vertically 2s ease-in-out and fades out after the
 * user scrolls past ~100px. Respects `prefers-reduced-motion`.
 *
 * Uses `mix-blend-mode: difference` so the label stays legible on
 * both the Cinzia (black/white) and All Design (warm greige) halves
 * of the split-container without needing per-side theming.
 */
import React, { useEffect, useState } from 'react';

export default function HomeScrollIndicator() {
    const [dim, setDim] = useState(false);

    useEffect(() => {
        const onScroll = () => setDim(window.scrollY > 100);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <div
            className={`home-scroll-indicator ${dim ? 'is-dim' : ''}`}
            aria-hidden="true"
            data-testid="home-scroll-indicator"
        >
            <span className="home-scroll-indicator__pill">
                <span className="home-scroll-indicator__label">SCROLL</span>
                <span className="home-scroll-indicator__arrow">↓</span>
            </span>
        </div>
    );
}
